import React, { useEffect, useState, useContext } from "react";
import jMoment from "moment-jalaali";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Input from "../../../shared/components/Input";
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_VALIDATED,
  VALIDATOR_AUTOCOMPLETE,
  VALIDATOR_DATE,
  VALIDATOR_SELECT,
} from "../../../shared/util/validators";
import useForm from "../../../shared/hooks/form-hooks";

import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ProcessCardContainerDoctors from "../components/ProcessCardContainerDoctors";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import { useSnackbar } from "notistack";
import { AuthContext } from "../../../context/AuthContext";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AdapterJalaali from "@date-io/jalaali";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import { Routes, Route, useNavigate } from "react-router-dom";

import MessagesContainerDoctors from "../components/MessagesContainerDoctors";

const OrderDetailsDoctors = () => {
  const auth = useContext(AuthContext);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const orderId = useParams().oId;
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [process, setProcess] = useState();
  const [initials, setInitials] = useState();

  jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

  //getting the route it came from
  const prevRoute = useSelector((state) => state.routeReducer.prevRoute);

  //getting order details and process
  useEffect(() => {
    axios
      .post(
        "/api/v1/doctors/get-order-process",
        {
          orderId: Number(orderId),
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        setInitials(response.data.data);
        setIsLoading(false);
      })
      .catch((e) => {
        const messages = e.response.data.data;
        setIsLoading(false);
        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
      });
  }, []);

  //test
  // useEffect(() => {
  //   console.log(initials);
  // }, [initials]);

  return (
    <React.Fragment>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Paper sx={{ flexGrow: 1, maxWidth: 1200, p: 4 }}>
        {initials && (
          <Grid container spacing={5}>
            <Grid xs={12} md={12}>
              <Link
                to={prevRoute}
                style={{ color: "inherit", textDecoration: "inherit" }}
              >
                <Button fullWidth color="primary" variant="contained">
                  <ArrowBackIcon
                    sx={{ mx: 1 }}
                    onClick={() => {
                      navigate(prevRoute);
                    }}
                  />
                  بازگشت
                </Button>
              </Link>
            </Grid>
            <Grid xs={12} md={4}>
              <TextField
                id="patientName"
                label="نام بیمار"
                variant="standard"
                fullWidth
                defaultValue={initials.patiantName}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid xs={12} md={4}>
              <TextField
                id="boxNumber"
                label="شماره جعبه"
                variant="standard"
                fullWidth
                defaultValue={initials.boxNumber}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid xs={12} md={4}>
              <TextField
                id="jawCount"
                label="تعداد فک"
                variant="standard"
                fullWidth
                defaultValue={initials.jawCount}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid xs={12} md={4}>
              <TextField
                id="unitCount"
                label="تعداد واحد"
                variant="standard"
                fullWidth
                defaultValue={initials.unitCount}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid xs={12} md={4}>
              <TextField
                id="startDate"
                label="تاریخ شروع"
                variant="standard"
                fullWidth
                defaultValue={jMoment(Number(initials.startDate)).format(
                  "jYY/jMM/jDD"
                )}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid xs={12} md={4}>
              <TextField
                id="endDate"
                label="تاریخ پایان"
                variant="standard"
                fullWidth
                defaultValue={
                  initials.endDate
                    ? jMoment(Number(initials.endDate)).format("jYY/jMM/jDD")
                    : "(در حال انجام)"
                }
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>
        )}

        {initials?.process && (
          <ProcessCardContainerDoctors
            orderProcesses={initials.process}
            orderTypeProcesses={initials.orderTyoeProcess}
          />
        )}
        <MessagesContainerDoctors orderId={orderId} />
      </Paper>
    </React.Fragment>
  );
};

export default OrderDetailsDoctors;
